module.exports = __webpack_public_path__ + "static/media/13_5.e08a4ff6.jpg";